export class TipologiaFascicoloCorrelataDTO {
  codice: string;
  nome: string;
  id: string;
}
